module.exports = __webpack_public_path__ + "img/list_code.6e92f856.svg";